import { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { zodResolver } from '@hookform/resolvers/zod';
import { dependenciaSchema } from '../../../../schemas/dependenciaSchema';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { MODE } from '../../../../interaces/mode.interface';
import { ENUM_ACTIONS } from '../../../../interaces/enums/enums.interface';
import { dependenciesApi } from '../../api/dependencies.api';
import ConfirmationMessage from '../../../../components/GenericComponents/ConfirmationMessage';
import BoxConfirmation from '../../../../components/GenericComponents/BoxConfirmation';
import { justNumbersAndLetters, justLetters } from '../../../../services/helpers';
import {
  TOAST_ERROR_IDS,
  TOAST_INFO_IDS,
  TOAST_SUCCESS_IDS,
} from '../../../../interaces/toast.ids.interface';
import { streamData } from '../../../../services/helpers';
import Select from 'react-select';
import { STATUS } from '../../interfaces/dependencies.interface';
import { updateDataWhenCreate, updateDataWhenUpdate } from '../../../../services/helpers';
import styles from '../../styles/styles.module.css';

function ModalDependence({ onClose, model = null, mode = MODE.CREATE, setEntities }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    resolver: zodResolver(dependenciaSchema),
  });
  const [openModalConfirmation, setOPenModalConfirmation] = useState(false);
  const [confirmDisablemodel, setConfirmDisablemodel] = useState(false);
  const [data, setData] = useState(null);
  const [deleteInfo, setDeleteInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [modelName, setmodelName] = useState('');

  useEffect(() => {
    if (model && mode === MODE.UPDATE) {
      reset({
        rfc: model.rfc || '',
        name: model.name || '',
        organism: model.organism || '',
        status: model.status,
      });
    } else {
      reset({
        rfc: '',
        name: '',
        organism: '',
        status: true,
      });
    }
  }, [model, mode, reset]);

  const onSubmit = async (data) => {
    setData(data);
    setLoading(true);
    try {
      streamData(data);
      if (mode === MODE.CREATE) {
        const response = await dependenciesApi.create(data);
        updateDataWhenCreate(setEntities, response);
      } else {
        delete data.rfc;
        if (
          model.status === data.status &&
          model.organism === data.organism &&
          model.name === data.name
        ) {
          toast(TOAST_INFO_IDS.NO_DATA_TO_UPDATE, {
            icon: 'ℹ️',
            id: TOAST_INFO_IDS.NO_DATA_TO_UPDATE,
          });
          setLoading(false);
          return;
        }
        if (model.status === true && data.status === false) {
          setOPenModalConfirmation(true);
          await getDeleteIfo();
          setLoading(false);
          return;
        }
        const response = await dependenciesApi.update(model.id, data);
        updateDataWhenUpdate(setEntities, response);
      }
      toast.success(
        mode === MODE.CREATE
          ? TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY
          : TOAST_SUCCESS_IDS.RECORD_UPDATED_SUCCESSFULLY,
        { id: TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY }
      );
      onClose();
    } catch (error) {
      toast.error(
        (error.message && error.message !== 'Error'
          ? error.message
          : TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION) ||
          TOAST_ERROR_IDS.ERROR_PERFORMING_THIS_ACTION,
        { id: TOAST_ERROR_IDS.TWO }
      );
    } finally {
      setLoading(false);
    }
  };

  const onConfirmWithInput = async () => {
    setLoading(true);
    const newmodelNameStream = streamData(modelName);
    if (newmodelNameStream.length === 0) {
      setLoading(false);
      return toast(TOAST_INFO_IDS.ENTER_THE_REQUESTED_INFORNATION, {
        icon: 'ℹ️',
        id: TOAST_INFO_IDS.ENTER_THE_REQUESTED_INFORNATION,
      });
    }

    if (model.name !== newmodelNameStream) {
      setLoading(false);
      toast.error(TOAST_ERROR_IDS.NO_MATCH_model_NAME, { id: TOAST_ERROR_IDS.NO_MATCH_model_NAME });
      return;
    }
    try {
      data.confirmationName = newmodelNameStream;
      streamData(data);
      await dependenciesApi.update(model.id, data);
      onClose();
      toast.success(TOAST_SUCCESS_IDS.model_SUCCESSFULLY_DISABLED, {
        id: TOAST_SUCCESS_IDS.model_SUCCESSFULLY_DISABLED,
      });
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  const onDisablemodel = async () => {
    setConfirmDisablemodel(true);
  };

  const getDeleteIfo = async () => {
    try {
      const response = await dependenciesApi.getDeleteInfo(model.id);
      setDeleteInfo(response);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };

  const [whereChanges, setWhereChanges] = useState(false);
  useEffect(() => {
    setWhereChanges(isDirty);
  }, [isDirty]);
  return (
    <div className="modal-overlay">
      <div className="modal-content modal-sizes">
        <div className="modal-header">
          <h2 className="modal-title ">{model ? ENUM_ACTIONS.Update+'Dedependencia' :  ENUM_ACTIONS.Create+'Dependencia'}</h2>
          <button type="button" onClick={onClose} className="modal-close-btn">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            Captura los datos fiscales y organism relacionado.
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="modal-form">
            <div className="modal-div-columns">
              <div className="modal-div-column">
                <label className="label-base">
                  RFC<p className="modal-input-required">*</p>
                </label>
                <input
                  disabled={mode === MODE.UPDATE}
                  type="text"
                  maxLength={13}
                  {...register('rfc', {
                    onChange: (e) => justNumbersAndLetters(e),
                  })}
                  placeholder="RFC"
                  className="input-base"
                />
                {errors.rfc && <span className="error-text">{errors.rfc.message}</span>}
              </div>
              <div className="modal-div-column">
                <label className="label-base">
                  Estatus<p className="modal-input-required">*</p>
                </label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={STATUS}
                      getOptionLabel={(option) => option.value}
                      getOptionValue={(option) => option.key}
                      value={STATUS.find((option) => option.key === field.value) || null}
                      onChange={(option) => field.onChange(option?.key === true)}
                      placeholder="Todos los Estatus"
                      isSearchable={false}
                    />
                  )}
                />
                {errors.status && <span className="error-text">{errors.status.message}</span>}
              </div>
            </div>

            <div className="modal-div-column-one">
              <label className="label-base">
                Nombre<p className="modal-input-required">*</p>
              </label>
              <input
                {...register('name', {
                  onChange: (e) => justLetters(e),
                })}
                placeholder="Nombre de la dependencia"
                className="input-base"
              />
              {errors.name && <span className="error-text">{errors.name.message}</span>}
            </div>

            <div className="modal-div-column-one">
              <label className="label-base">Organismo</label>
              <input
                {...register('organism', {
                  onChange: (e) => justLetters(e),
                })}
                placeholder="Organismo"
                className="input-base"
              />
              {errors.organism && <span className="error-text">{errors.organism.message}</span>}
            </div>

            <div className="modal-footer">
              <button type="button" onClick={onClose} className="btn-cancel">
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading === true || (!whereChanges && mode === MODE.UPDATE)}
                className="btn-primary"
              >
                {loading ? 'Guardando...' : mode === MODE.CREATE ? 'Agregar' : 'Actualizar'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {openModalConfirmation && (
        <ConfirmationMessage
          message={'¿Deseas continuar con la desactivación de esta dependencia?'}
          onConfirm={onDisablemodel}
          onCancel={() => {
            setOPenModalConfirmation(false);
            setLoading(false);
          }}
          deleteInfo={deleteInfo}
        />
      )}

      {confirmDisablemodel && (
        <BoxConfirmation
          message={`Para confirmar esta acción, por favor ingresa el name de la dependencia:${model.name}`}
          onConfirm={onConfirmWithInput}
          onCancel={() => {
            setConfirmDisablemodel(false);
            setLoading(false);
            setmodelName('');
          }}
          model={model}
          label={'Nombre de la dependencia:'}
          inputValue={modelName}
          setInputValue={setmodelName}
        />
      )}
    </div>
  );
}

export default ModalDependence;
